module.exports = __webpack_public_path__ + "static/media/galerija_2022_0054.7eb38b48.jpg";